// Formulaire de collaboration de Marie-Eve : construit les étapes à partir des questions,
// valide chaque étape, puis envoie les réponses à son Google Forms.
(function () {
  var EN = /^en/i.test(document.documentElement.lang || '');
  var L = EN
    ? { facultatif: '(optional)', plusieurs: '(choose all that apply)', autre: 'Other:', autreAria: 'Other answer', choisis: 'Please choose at least one answer.', precise: 'Please specify your “Other” answer.', section: 'Section', sur: 'of' }
    : { facultatif: '(facultatif)', plusieurs: '(plusieurs choix possibles)', autre: 'Autre :', autreAria: 'Autre réponse', choisis: 'Choisis au moins une réponse.', precise: 'Précise ta réponse « Autre ».', section: 'Section', sur: 'sur' };
  function texte(o) { return EN && o.te ? o.te : o.t; }
  function echap(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function typeTexte(t) { return /courriel/i.test(t) ? 'email' : /t[ée]l[ée]phone/i.test(t) ? 'tel' : 'text'; }
  function auto(t) {
    return /nom complet/i.test(t) ? 'name' : /entreprise/i.test(t) ? 'organization' : /courriel/i.test(t) ? 'email'
      : /t[ée]l[ée]phone/i.test(t) ? 'tel' : /site web/i.test(t) ? 'url' : 'off';
  }
  function question(q) {
    var id = 'q' + q.e, nom = 'entry.' + q.e;
    var marque = q.o ? ' <span class="duo-collab__requis" aria-hidden="true">*</span>' : ' <span class="duo-collab__facultatif">' + L.facultatif + '</span>';
    if (q.k === 'c' || q.k === 'p') {
      var champ = q.k === 'c'
        ? '<input id="' + id + '" name="' + nom + '" type="' + typeTexte(q.t) + '" autocomplete="' + auto(q.t) + '"' + (q.o ? ' required' : '') + '>'
        : '<textarea id="' + id + '" name="' + nom + '" rows="4"' + (q.o ? ' required' : '') + '></textarea>';
      return '<div class="duo-collab__champ"><label for="' + id + '">' + echap(texte(q)) + marque + '</label>' + champ + '</div>';
    }
    var type = q.k === 'x' ? 'checkbox' : 'radio';
    var h = '<fieldset class="duo-collab__champ duo-collab__groupe" data-requis="' + (q.o ? 1 : 0) + '" data-type="' + type + '"><legend>' + echap(texte(q)) + marque
      + (type === 'checkbox' ? ' <span class="duo-collab__facultatif">' + L.plusieurs + '</span>' : '') + '</legend>';
    (q.c || []).forEach(function (c, n) {
      var vu = EN && q.ce ? q.ce[n] : c;
      h += '<label class="duo-collab__choix"><input type="' + type + '" name="' + nom + '" value="' + echap(c) + '"><span>' + echap(vu) + '</span></label>';
    });
    if (q.a) {
      h += '<label class="duo-collab__choix duo-collab__choix--autre"><input type="' + type + '" name="' + nom + '" value="__other_option__"><span>' + L.autre + '</span>'
        + '<input type="text" class="duo-collab__autre" name="' + nom + '.other_option_response" aria-label="' + L.autreAria + '"></label>';
    }
    return h + '<p class="duo-collab__erreur" role="alert" hidden>' + L.choisis + '</p></fieldset>';
  }

  function demarrer(racine) {
    var donneesQ = JSON.parse(racine.querySelector('[data-questions]').textContent);
    var conteneur = racine.querySelector('[data-etapes]');
    conteneur.innerHTML = donneesQ.map(function (e, i) {
      return '<fieldset class="duo-collab__etape" data-etape="' + i + '"' + (i ? ' hidden' : '') + '><legend class="duo-collab__legende"><small>' + L.section + ' '
        + (i + 1) + ' ' + L.sur + ' ' + donneesQ.length + '</small>' + echap(texte(e)) + '</legend>' + e.q.map(question).join('') + '</fieldset>';
    }).join('');

    var form = racine.querySelector('[data-formulaire]');
    var etapes = racine.querySelectorAll('[data-etape]');
    var prec = racine.querySelector('[data-precedent]'), suiv = racine.querySelector('[data-suivant]');
    var barre = racine.querySelector('[data-progres]');
    var i = 0;

    function montrer(n) {
      i = n;
      etapes.forEach(function (e, j) { e.hidden = j !== i; });
      prec.hidden = i === 0;
      racine.toggleAttribute('data-derniere', i === etapes.length - 1);
      majBarre();
    }
    // La barre suit toujours la section réellement affichée.
    function majBarre() {
      var visible = Array.prototype.findIndex.call(etapes, function (e) { return !e.hidden; });
      var pct = ((visible < 0 ? i : visible) + 1) / etapes.length * 100;
      barre.style.transition = 'none';
      barre.style.width = pct + '%';
      requestAnimationFrame(function () { barre.style.transition = ''; });
    }
    function haut() { racine.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    function valide(etape) {
      var ok = true, premier = null;
      etape.querySelectorAll('input[type=text]:not(.duo-collab__autre),input[type=email],input[type=tel],textarea').forEach(function (c) {
        if (!c.checkValidity()) { ok = false; premier = premier || c; }
      });
      etape.querySelectorAll('.duo-collab__groupe').forEach(function (g) {
        var coches = g.querySelectorAll('input[type=' + g.dataset.type + ']:checked');
        var autre = g.querySelector('input[value="__other_option__"]');
        var texteAutre = g.querySelector('.duo-collab__autre');
        var erreur = g.querySelector('.duo-collab__erreur');
        var manque = g.dataset.requis === '1' && coches.length === 0;
        var autreVide = !!(autre && autre.checked && texteAutre && !texteAutre.value.trim());
        erreur.textContent = autreVide ? L.precise : L.choisis;
        erreur.hidden = !(manque || autreVide);
        if (manque || autreVide) { ok = false; premier = premier || (autreVide ? texteAutre : g.querySelector('input')); }
      });
      if (!ok && premier) { if (premier.reportValidity && premier.type !== 'radio' && premier.type !== 'checkbox') premier.reportValidity(); premier.focus(); }
      return ok;
    }

    racine.querySelectorAll('.duo-collab__autre').forEach(function (t) {
      t.addEventListener('input', function () {
        var c = t.parentNode.querySelector('input[value="__other_option__"]');
        if (t.value.trim() && c) c.checked = true;
      });
    });
    racine.addEventListener('change', function (ev) {
      var g = ev.target.closest && ev.target.closest('.duo-collab__groupe');
      if (g) g.querySelector('.duo-collab__erreur').hidden = true;
    });
    suiv.addEventListener('click', function () { if (valide(etapes[i])) { montrer(i + 1); haut(); } });
    prec.addEventListener('click', function () { montrer(i - 1); haut(); });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      // Entrée dans un champ avant la fin : on passe à la section suivante, on n'envoie pas.
      if (i < etapes.length - 1) {
        if (valide(etapes[i])) { montrer(i + 1); haut(); }
        return;
      }
      // Dernière vérification de toutes les sections avant l'envoi.
      for (var n = 0; n < etapes.length; n++) {
        if (n !== i) { etapes[n].hidden = false; }
        var bonne = valide(etapes[n]);
        if (n !== i) { etapes[n].hidden = true; }
        if (!bonne) { montrer(n); valide(etapes[n]); haut(); return; }
      }
      montrer(i);
      var envoi = new URLSearchParams();
      form.querySelectorAll('input,textarea').forEach(function (c) {
        if (!c.name) return;
        if ((c.type === 'radio' || c.type === 'checkbox') && !c.checked) return;
        if (c.classList.contains('duo-collab__autre')) {
          var choix = c.parentNode.querySelector('input[value="__other_option__"]');
          if (!choix || !choix.checked) return;
        }
        if (c.type !== 'radio' && c.type !== 'checkbox' && !c.value.trim()) return;
        envoi.append(c.name, c.value.trim());
      });
      envoi.append('fvv', '1');
      envoi.append('pageHistory', Array.from({ length: etapes.length + 1 }, function (_, n) { return n; }).join(','));
      var bouton = form.querySelector('.duo-collab__envoi');
      bouton.disabled = true;
      fetch(racine.dataset.action, { method: 'POST', mode: 'no-cors', body: envoi })
        .then(function () {
          form.hidden = true;
          var merci = racine.querySelector('[data-merci]');
          merci.hidden = false;
          barre.style.width = '100%';
          merci.focus();
          haut();
        })
        .catch(function () {
          bouton.disabled = false;
          form.querySelector('[data-erreur-envoi]').hidden = false;
        });
    });
    montrer(0);
  }

  function tout() { document.querySelectorAll('[data-duo-collab]:not([data-pret])').forEach(function (r) { r.setAttribute('data-pret', ''); demarrer(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  document.addEventListener('shopify:section:load', tout);
})();
